import { render, staticRenderFns } from "./type70.vue?vue&type=template&id=76c7b76a&scoped=true"
import script from "./type70.vue?vue&type=script&lang=js"
export * from "./type70.vue?vue&type=script&lang=js"
import style0 from "./type70.vue?vue&type=style&index=0&id=76c7b76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7b76a",
  null
  
)

export default component.exports